import { IOperation } from '@shared/undo/operation/i-operation';
import { ApplicationRefreshService } from '@services/application-refresh.service';
import { UniformDirectPrintingService } from './uniform-direct-printing.service';
import { UniformDirectPrintingModel } from './uniform-direct-printing.model';
import { Connection } from '@3d-scene/model3d/connection';
import { SimpleTextValueVO, TextureAreaUsageVO } from '@shared/vo/meta-element.vo';
import { HtmlUtils } from '@shared/util/html-utils';

export class DeactivateUniformDirectPrintingOperation implements IOperation {

  private _uniformFontSize: number | undefined = undefined;
  private _connectionAndSize: { connection: Connection, fontSize: number }[] = [];

  constructor(
    private readonly uniformDirectPrintingService: UniformDirectPrintingService,
    private readonly uniformDirectPrintingModel: UniformDirectPrintingModel,
    private readonly applicationRefreshService: ApplicationRefreshService,
  ) {
  }

  public getQualifiedClassName(): string {
    return DeactivateUniformDirectPrintingOperation.name;
  }

  public async performRedo(): Promise<void> {
    this._connectionAndSize = [];
    this._uniformFontSize = this.uniformDirectPrintingModel.uniformFontSize;
    this.uniformDirectPrintingModel.useUniformDirectPrintingFontSize = false;
    this.uniformDirectPrintingModel.uniformFontSize = undefined;
    const textCheckConnections = this.uniformDirectPrintingService.getTextCheckConnections();
    await this.uniformDirectPrintingService.loadTextCheckInfos(textCheckConnections);
    this.resetFontSizes(textCheckConnections);
    await this.applicationRefreshService.refreshProject();
  }

  public async performUndo(): Promise<void> {
    this.uniformDirectPrintingModel.useUniformDirectPrintingFontSize = true;
    this.uniformDirectPrintingModel.uniformFontSize = this._uniformFontSize;
    for (const { connection, fontSize } of this._connectionAndSize) {
      const textValue = (connection.metaElementUsage as TextureAreaUsageVO).textValue as SimpleTextValueVO;
      textValue.text = HtmlUtils.updateLegacyFontParagraphFontSize(textValue.text, { fontSize });
      connection.isTextureLoaded = false;
    }
    await this.applicationRefreshService.refreshProject();
  }

  public getOperationDescription(): string {
    return '';
  }

  private resetFontSizes(textCheckConnections: Connection[]) {
    for (const textCheckConnection of textCheckConnections) {
      const textSizeCheck = this.uniformDirectPrintingService.getFirstMatchingTextCheck(textCheckConnection);
      if (textSizeCheck) {
        if (textCheckConnection.metaElementUsage instanceof TextureAreaUsageVO) {
          if (textCheckConnection.metaElementUsage.textValue instanceof SimpleTextValueVO) {
            this.storeFontSizeForUndo(textCheckConnection, textCheckConnection.metaElementUsage.textValue);
            textCheckConnection.metaElementUsage.textValue.text = HtmlUtils.updateLegacyFontParagraphFontSize(textCheckConnection.metaElementUsage.textValue.text, { fontSize: textSizeCheck.fontSize });
            textCheckConnection.isTextureLoaded = false;
          }
        }
      }
    }
  }

  private storeFontSizeForUndo(connection: Connection, textValue: SimpleTextValueVO) {
    const fontSizeValues = HtmlUtils.extractLegacyFontSizeValues(textValue.text);
    if (fontSizeValues.length > 0) {
      this._connectionAndSize.push({ connection, fontSize: Math.max(...fontSizeValues) });
    }
  }
}
